import { instantBaseApi } from "@/services/instantApi";
import { ShopMetaByKeyDocument, ShopMetaCreateOrUpdateDocument } from "./gql";

export const META_KEY_GENERATOR_CONFIG = 'global_style_generator_config';

export const getShopMetaByKey = async (key) => {
  return await instantBaseApi(
    JSON.stringify({
      query: ShopMetaByKeyDocument,
      variables: {
        key
      }
    })
  );
}

export const shopMetaCreateOrUpdateDocument = async (key, value) => {
  return await instantBaseApi(
    JSON.stringify({
      query: ShopMetaCreateOrUpdateDocument,
      variables: {
        input: {
          key,
          value: JSON.stringify(value)
        },
      }
    })
  );
}
